// extracted by mini-css-extract-plugin
module.exports = {"label":"FormSelect_label__4j9dr","selectBox":"FormSelect_selectBox__1PN5Z","selectWrapper":"FormSelect_selectWrapper__1nKAU"};